import { useAuthStore } from "@/Stores/AuthStore";

export const useAuthUser = () => useAuthStore((state) => state.authUser);
